import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Slide from "react-reveal/Slide";
import ExpansionPanel from "@material-ui/core/ExpansionPanel";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./styles.css";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "80%",
    margin: "0 auto",
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightMedium,
    fontFamily: "Comfortaa",
    width: "10rem",
    padding: "5px",
  },
  icon: {
    marginLeft: "5px",
  },
  content: {
    fontFamily: "Comfortaa",
    fontSize: theme.typography.pxToRem(14),
    fontWeight: theme.typography.fontWeightLight,
    textAlign: "left",
  },
}));

const Skills = () => {
  const classes = useStyles();
  return (
    <div className="skills-section">
      <div className="container">
        <Slide bottom>
          <div className="row">
            <div className="col-sm-6 about-me">
              <h1>What I Do</h1>

              <p className="about-me-text">
                I work primarily with Python for data engineering, modelling, software engineering, and API development.
                I'm particularly interested in building ML systems that scale. I've built end-to-end systems using tools
                like Kubernetes and the Elastic stack to achieve this.
                <br></br>
                <br></br>
                For cloud services I have used both AWS and Azure for managing
                production deployments.
                <br></br>
                <br></br>
                For Machine Learning I am mostly using Pytorch these days for model development and design, but I have
                extensively used Tensorflow/Keras in the past. My specialities within ML lie primarily in NLP and Explainable AI. 
                <br></br>
                <br></br>I also use Go wherever I can and for building high
                performance systems and services. It's awesome.
              </p>
            </div>
            <div className="col-sm-6 about-me">
              <h1>What I Use</h1>
              <Grid container spacing={6}>
                <Grid item xs={3}>
                  <img
                    src="https://www.vectorlogo.zone/logos/amazon_aws/amazon_aws-icon.svg"
                    alt="aws"
                    width="50"
                    height="50"
                  />{" "}
                </Grid>
                <Grid item xs={3}>
                  <img
                    src="https://www.vectorlogo.zone/logos/microsoft_azure/microsoft_azure-icon.svg"
                    alt="azure"
                    width="50"
                    height="50"
                  />{" "}
                </Grid>
                <Grid item xs={3}>
                  <img
                    src="https://www.vectorlogo.zone/logos/gnu_bash/gnu_bash-icon.svg"
                    alt="bash"
                    width="50"
                    height="50"
                  />{" "}
                </Grid>
                <Grid item xs={3}>
                  <img
                    src="https://d3r49iyjzglexf.cloudfront.net/circleci-logo-stacked-fb-657e221fda1646a7e652c09c9fbfb2b0feb5d710089bb4d8e8c759d37a832694.png"
                    alt="CircleCI"
                    width="50"
                    height="50"
                  />{" "}
                </Grid>
                <Grid item xs={3}>
                  <img
                    src="https://www.vectorlogo.zone/logos/docker/docker-icon.svg"
                    alt="docker"
                    width="50"
                    height="50"
                  />{" "}
                </Grid>
                <Grid item xs={3}>
                  <img
                    src="https://www.vectorlogo.zone/logos/elastic/elastic-icon.svg"
                    alt="elastic"
                    width="50"
                    height="50"
                  />{" "}
                </Grid>
                <Grid item xs={3}>
                  <img
                    src=" https://warehouse-camo.ingress.cmh1.psfhosted.org/c85479a07f8c2c1e96852331cf34c69a0501a0b3/68747470733a2f2f666173746170692e7469616e676f6c6f2e636f6d2f696d672f6c6f676f2d6d617267696e2f6c6f676f2d7465616c2d766563746f722e737667"
                    alt="fastAPI"
                    width="65"
                    height="50"
                  />{" "}
                </Grid>
                <Grid item xs={3}>
                  <img
                    src="https://www.vectorlogo.zone/logos/git-scm/git-scm-icon.svg"
                    alt="git"
                    width="50"
                    height="50"
                  />{" "}
                </Grid>
                <Grid item xs={3}>
                  <img
                    src="https://www.vectorlogo.zone/logos/golang/golang-vertical.svg"
                    alt="go"
                    width="50"
                    height="50"
                  />{" "}
                </Grid>
                <Grid item xs={3}>
                  <img
                    src="https://www.vectorlogo.zone/logos/javascript/javascript-icon.svg"
                    alt="javascript"
                    width="50"
                    height="50"
                  />{" "}
                </Grid>
                <Grid item xs={3}>
                  <img
                    src="https://www.vectorlogo.zone/logos/kubernetes/kubernetes-icon.svg"
                    alt="kubernetes"
                    width="50"
                    height="50"
                  />{" "}
                </Grid>
                <Grid item xs={3}>
                  <img
                    src="https://www.vectorlogo.zone/logos/linux/linux-icon.svg"
                    alt="linux"
                    width="50"
                    height="50"
                  />{" "}
                </Grid>
                <Grid item xs={3}>
                  <img
                    src="https://www.vectorlogo.zone/logos/postgresql/postgresql-icon.svg"
                    alt="postgresql"
                    width="50"
                    height="50"
                  />{" "}
                </Grid>
                <Grid item xs={3}>
                  <img
                    src="https://www.vectorlogo.zone/logos/python/python-icon.svg"
                    alt="python"
                    width="50"
                    height="50"
                  />{" "}
                </Grid>
                <Grid item xs={3}>
                  <img
                    src="https://www.vectorlogo.zone/logos/pytorch/pytorch-icon.svg"
                    alt="pytorch"
                    width="50"
                    height="50"
                  />{" "}
                </Grid>
                <Grid item xs={3}>
                  <img
                    src="https://www.vectorlogo.zone/logos/reactjs/reactjs-icon.svg"
                    alt="react"
                    width="50"
                    height="50"
                  />{" "}
                </Grid>

                <Grid item xs={3}>
                  <img
                    src="https://www.vectorlogo.zone/logos/tensorflow/tensorflow-icon.svg"
                    alt="tensorflow"
                    width="50"
                    height="50"
                  />{" "}
                </Grid>

                <Grid item xs={3}>
                  <img
                    src="https://www.vectorlogo.zone/logos/mongodb/mongodb-icon.svg"
                    alt="mongodb"
                    width="50"
                    height="50"
                  />{" "}
                </Grid>
                
              </Grid>
            </div>
            {/* <div className="col md-6 about-me">
              <br />
              <br />
              <div className={classes.root}>
                <ExpansionPanel>
                  <ExpansionPanelSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  >
                    <Typography className={classes.heading}>Python</Typography>
                    <Typography className={classes.icon}>
                      <i
                        class="fab fa-python fa-3x"
                        style={{ color: "#00d1b2" }}
                      ></i>
                    </Typography>
                  </ExpansionPanelSummary>
                  <ExpansionPanelDetails>
                    <Typography className={classes.content}>
                      <hr />
                      I've been a Python programmer for a number of years and
                      use it as my primary tool for working with data and
                      building software. I'm highly experienced using Numpy and
                      Pandas for data analysis, manipulation and processing. For
                      machine learning I use libraries such as Scikit-learn,
                      Tensorflow, Pytorch. For NLP related projects I like to
                      use tools like Spacy and Hugging Face's Tranformers
                      package for modelling and implementing state of the art
                      NLP algorithms. <br />
                      <br />
                      I use Jupyter lab and notebooks extensively when exploring
                      datasets.
                      <br />
                      <br />
                      I'm a big fan of Plotly's Dash library for creating sleek
                      and interactive user dashboards for presenting data.
                    </Typography>
                  </ExpansionPanelDetails>
                </ExpansionPanel>
                <ExpansionPanel>
                  <ExpansionPanelSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel2a-content"
                    id="panel2a-header"
                  >
                    <Typography className={classes.heading}>
                      Intelligent Systems and Insights
                    </Typography>
                    <Typography className={classes.icon}>
                      <i
                        class="fas fa-brain fa-2x"
                        style={{ color: "#00d1b2" }}
                      ></i>
                    </Typography>
                  </ExpansionPanelSummary>
                  <ExpansionPanelDetails>
                    <Typography className={classes.content}>
                      <hr />
                      Intelligent systems and analysis are at the core of what I
                      do. The most important aspect of my job is to build data
                      driven products and derive insights that add value.
                      Whatever I build or develop I always strive to keep its
                      end use at the forefront.
                      <br />
                      <br />
                      I've a strong interest in Explainable A.I. - a new and
                      emerging field in data science. Explainable A.I. uses
                      concepts from game theory to help demystify the internal
                      operations of "black-box" models and also provides a guard
                      rail during the development of models to prevent against
                      data leakage and bias. I primarily use the Python package
                      <a href="https://github.com/slundberg/shap"> SHAP </a> to
                      conduct explainable analysis on models.
                    </Typography>
                  </ExpansionPanelDetails>
                </ExpansionPanel>
                <ExpansionPanel>
                  <ExpansionPanelSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel3a-content"
                    id="panel3a-header"
                  >
                    <Typography className={classes.heading}>
                      Software Development
                    </Typography>
                    <Typography className={classes.icon}>
                      <i
                        class="fas fa-laptop-code fa-2x"
                        style={{ color: "#00d1b2" }}
                      ></i>
                    </Typography>
                  </ExpansionPanelSummary>
                  <ExpansionPanelDetails>
                    <Typography className={classes.content}>
                      <hr />I enjoy taking an end-to-end approach with data
                      science, building functional software around ML tools, and
                      encorporating software engineering best practices to my
                      work.
                      <br />
                      <br />
                      I'm comforable developing API's to deliver model's as
                      services. In Python I typically use Flask to develop
                      API's. For front-end development I primarily use React and
                      JavaScript, and have used framworks such as Bootstrap and
                      Material-UI for layouts and design (including this site).
                      <br />
                      <br />
                      For CI/CD I'm comfortable using Docker for deploying
                      models and applications in a scalable and highly
                      maintainble manner.
                      <br />
                      <br />
                      I'm also a huge Go enthisiast and really enjoy developing
                      in the language due to its minimalism and transparency as
                      a language.
                    </Typography>
                  </ExpansionPanelDetails>
                </ExpansionPanel>
              </div>
            </div> */}
          </div>
        </Slide>
      </div>
    </div>
  );
};

export default Skills;
